<template>
  <card>
    <table class="table">
      <thead>
        <tr>
          <th>Keywords</th>
          <th>Impresiones</th>
          <th>Clicks</th>
          <th>CPC medio</th>
          <th>CTR medio</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(keywordData, index) in keywordData" :key="index">
          <td>{{ keywordData.keyword }}</td>
          <td>{{ Number(keywordData.impressions).toLocaleString() }}</td>
          <td>{{ Number(keywordData.clicks).toLocaleString() }}</td>
          <td>${{ keywordData.cpc.toFixed(2).toLocaleString() }}</td>
          <td>{{ keywordData.ctr.toFixed(2).toLocaleString() }}%</td>
        </tr>
      </tbody>
      <thead>
        <tr>
          <th>Total</th>
          <th>
            {{
              productData.TotalImpressions.toLocaleString()
            }}
          </th>
          <th>
            {{
              productData.TotalClicks.toLocaleString()
            }}
          </th>
          <th>
            ${{
              
                productData.TotalCpc.toFixed(2).toLocaleString()
            }}
          </th>
          <th>
            {{
              productData.TotalCtr.toFixed(2).toLocaleString()
            }}%
          </th>
        </tr>
      </thead>
    </table>
  </card>
</template>
<script>
export default {
  name: "keywords-table",
  props: {
    keywordData: Array,
    productData: Object
  }
};
</script>
